module.exports = __webpack_public_path__ + "static/media/18ECA6.3257aa51.jpg";